import { Box, Container, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { motion } from "framer-motion";
import PropTypes from "prop-types";
import React from "react";
import {
  varFadeInRight,
  varFadeInUp,
  varWrapEnter,
} from "src/components/Animate";

// ----------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    backgroundColor: "black",
    [theme.breakpoints.up("md")]: {
      top: 0,
      left: 0,
      width: "100%",
      height: "40vh",
      display: "flex",
      position: "fixed",
      alignItems: "center",
    },
  },
  content: {
    zIndex: 10,
    margin: "auto",
    textAlign: "center",
    position: "relative",
    paddingTop: theme.spacing(20),
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.up("md")]: {
      margin: "unset",
      textAlign: "center",
    },
  },
  mainOverlay: {
    zIndex: 9,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    position: "absolute",
    opacity: "0.7 !important",
  },
  mainImg: {
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 8,
    opacity: "0.5 !important",
    width: "100%",
    height: "-webkit-fill-available",
    position: "absolute",
    objectFit: "cover",
    [theme.breakpoints.up("lg")]: {
      width: "100%",
    },
  },
}));

// ----------------------------------------------------------------------

Main.propTypes = {
  className: PropTypes.string,
};

function Main({ className }) {
  const classes = useStyles();

  return (
    <>
      <motion.div
        initial="initial"
        animate="animate"
        variants={varWrapEnter}
        className={clsx(classes.root, className)}
      >
        <motion.img
          alt="gorges du tarn"
          src="/img/activity.JPG"
          variants={varFadeInUp}
          className={classes.mainImg}
        />

        <Container maxWidth="lg">
          <div className={classes.content}>
            <motion.div variants={varFadeInRight}>
              <Typography variant="h1" sx={{ color: "common.white" }}>
                CONTACT
              </Typography>
            </motion.div>
          </div>
        </Container>
      </motion.div>
      <Box sx={{ height: { md: "40vh" } }} />
    </>
  );
}

export default Main;
